/*
 * PauseScreen
 * ==========
 */

import ScreenBase from '../ui/ScreenBase'

export default class PauseScreen extends ScreenBase {

  constructor (game, screens) {
    super(game, 'pause');

    this.screens = screens;

    this.params = {
      'bg': [0, 0],
      'currentScore': [-280 / 2, -155 / 2],
      'currentScoreVal': [280 / 2, -155 / 2],
      'bestScore': [-280 / 2, -95 / 2],
      'bestScoreVal': [280 / 2, -95 / 2],
      'highestLevel': [-280 / 2, -35 / 2],
      'highestLevelVal': [280 / 2, -35 / 2],
      'bestWord': [-280 / 2, 25 / 2],
      'bestWordVal': [280 / 2, 25 / 2],
      'bestWordScore': [-280 / 2, 85 / 2],
      'bestWordScoreVal': [280 / 2, 85 / 2],
      'linesCleared': [-280 / 2, 145 / 2],
      'linesClearedVal': [280 / 2, 145 / 2],
      'title': [0 / 2, -268 / 2],
      'subtitle': [0 / 2, -220 / 2],
      'continue': [0 / 2, 250 / 2]
    };

    this.bg = this.addSprite('bg', 'uiScreens', 'uiPausePanel.png');

    this.statsOffsetY = -2 * PARAMS.scaleFactor;
    this.initSummaryStats();

    this.title = this.addText2('title', 'blue', 'Pause', 30);
    this.subtitle = this.addText2('subtitle', 'blue', 'All-time stats', 20);

    this.continue = this.addTextButton2('continue', 'uiButtonContinue', 'Continue', this.continueClicked);

    this.setInputForAllButtons(false)
  }

  initSummaryStats () {
    this.currentScore = this.addText2('currentScore', 'white', 'Current Score', 20, 0);
    this.currentScoreVal = this.addText2('currentScoreVal', 'white', '1120', 20, 1);
    this.bestScore = this.addText2('bestScore', 'white', 'Highest Score', 20, 0);
    this.bestScoreVal = this.addText2('bestScoreVal', 'white', '10124', 20, 1);
    this.highestLevel = this.addText2('highestLevel', 'white', 'Highest Level', 20, 0);
    this.highestLevelVal = this.addText2('highestLevelVal', 'white', '10', 20, 1);
    this.bestWord = this.addText2('bestWord', 'white', 'Best Word', 20, 0);
    this.bestWordVal = this.addText2('bestWordVal', 'white', 'IHAHA', 20, 1);
    this.bestWordScore = this.addText2('bestWordScore', 'white', 'Best Word\'s Score', 20, 0);
    this.bestWordScoreVal = this.addText2('bestWordScoreVal', 'white', '180', 20, 1);
    this.linesCleared = this.addText2('linesCleared', 'white', 'Lines Cleared', 20, 0);
    this.linesClearedVal = this.addText2('linesClearedVal', 'white', '10', 20, 1);

    this.currentScore.y += this.statsOffsetY;
    this.currentScoreVal.y += this.statsOffsetY;

    this.bestScore.y += this.statsOffsetY;
    this.bestScoreVal.y += this.statsOffsetY;

    this.highestLevel.y += this.statsOffsetY;
    this.highestLevelVal.y += this.statsOffsetY;

    this.bestWord.y += this.statsOffsetY;
    this.bestWordVal.y += this.statsOffsetY;

    this.bestWordScore.y += this.statsOffsetY;
    this.bestWordScoreVal.y += this.statsOffsetY;

    this.linesCleared.y += this.statsOffsetY;
    this.linesClearedVal.y += this.statsOffsetY
  }

  continueClicked (that) {
    that.screens.hideScreen()
  }

  onShowStarted () {
    super.onShowStarted();

    this.currentScoreVal.text = GS.score + '';
    this.bestScoreVal.text = STATS.highestScore + '';
    this.highestLevelVal.text = STATS.highestLevel + '';
    this.bestWordVal.text = (STATS.bestWord + '').toUpperCase().substring(0, 15);
    this.bestWordScoreVal.text = STATS.bestWordScore + '';
    this.linesClearedVal.text = STATS.linesCleared + ''
  }

  onHideEnded () {
    GS.resume();
    super.onHideEnded()
  }
}
